module.exports = { "default": require("core-js/library/fn/object/get-prototype-of"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/~/babel-runtime/core-js/object/get-prototype-of.js
// module id = 1210
// module chunks = 1